export const formTokenHeader = (token) => {
  return { headers: { Authorization: token } }
}
